require("core-js/features/promise");
// Note: About IE9 support, if we would need to support IE9, following is needed:
// * Different promise polyfill needed
//   require("promise/polyfill");
// * Polyfill for VueScrollTo to work.
//   require("raf/polyfill");


import Vue from "vue"
import { Component, Prop, Emit, Watch } from "vue-property-decorator"
import MoveOutContractsSelection from "../steps/move-out-contracts-selection.vue"
import MoveOutContractsSelectionDisplay from "../steps/move-out-contracts-selection-display.vue"
import MoveOutCustomerSelection from "../steps/move-out-customer-selection.vue"
import MoveOutCompanySelection from "../steps/move-out-company-selection.vue"
import MoveOutCustomerSelectionDisplay from "../steps/move-out-customer-selection-display.vue"
import MoveOutCompanySelectionDisplay from "../steps/move-out-company-selection-display.vue"
import PreProductSelection from "../steps/pre-product-selection.vue"
import PreProductSelectionDisplay from "../steps/pre-product-selection-display.vue"
import ProductSelection from "../steps/product-selection.vue"
import ProductSelectionDisplay from "../steps/product-selection-display.vue"
import Authentication from "../steps/authentication.vue"
import CustomerInformation from "../steps/customer-information.vue"
import CustomerInformationDisplay from "../steps/customer-information-display.vue";
import CompanyInformationDisplay from "../steps/company-information-display.vue";
import CompanyInformation from "../steps/company-information.vue"
import MoveOutMeteringPointInformation from "../steps/move-out-metering-point-information.vue"
import MoveOutMeteringPointInformationDisplay from "../steps/move-out-metering-point-information-display.vue"
import MoveOutSection from "../steps/move-out-section.vue"
import MoveOutProcessSelector from "../steps/move-out-process-selector.vue"
//import { SectionMode, ActionState } from "../../Default/common/section"
import { ValidationErrors } from "../../new-contract-vue";
import { CustomerTypeEnum, ProcessTypeEnum, SubProcessTypeEnum } from "../../../../../Scripts/inpulse/CommonEnums"
import { IProductViewModel, IPriceListViewModel, IContractViewModel } from "../../../../../Scripts/inpulse/I4UViewModels";
import { NewContractEvents } from "../../new-contract-vue-events";
import { SectionState, SectionMode, ActionState, SectionChecker } from "../../Default/common/section";
import SessionExpiration from "../../Default/common/session-expiration.vue";
import { MoveOutContractsChecker } from "../steps/move-out-contracts-selection";
import { MoveOutCustomerChecker } from "../steps/move-out-customer-selection";
import { MoveOutCompanyChecker } from "../steps/move-out-company-selection";
import { CustomerInformationChecker } from "../steps/customer-information";
import { CompanyInformationChecker } from "../steps/company-information";
import { PreProductSelectionChecker } from "../steps/pre-product-selection";
import { MoveOutProcessSelectorChecker } from "../steps/move-out-process-selector"
import { ProductSelectionChecker } from "../steps/product-selection";
import { MoveOutMeteringPointInformationChecker } from "../steps/move-out-metering-point-information";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(faArrowAltCircleRight);
Vue.component('font-awesome-icon', FontAwesomeIcon);

@Component({
    components: {
        MoveOutContractsSelection,
        MoveOutContractsSelectionDisplay,
        MoveOutCustomerSelection,
        MoveOutCompanySelection,
        MoveOutCustomerSelectionDisplay,
        MoveOutCompanySelectionDisplay,
        PreProductSelection,
        PreProductSelectionDisplay,
        ProductSelection,
        ProductSelectionDisplay,
        Authentication,
        CustomerInformation,
        CustomerInformationDisplay,
        CompanyInformation,
        CompanyInformationDisplay,
        MoveOutMeteringPointInformation,
        MoveOutMeteringPointInformationDisplay,
        MoveOutSection,
        MoveOutProcessSelector,
        SessionExpiration
    },
})

export default class PhaseMoveOut extends Vue {
    // Map store state's properties to computed properties.
    get moveOutUser(): string { return this.$store.state.moveOutUser; }
    get contracts(): IContractViewModel[] { return this.$store.state.contracts; }
    get contract(): IContractViewModel { return this.$store.state.contract; }
    get selectedProduct(): IProductViewModel { return this.$store.state.selectedProduct; }
    get selectedPriceList(): IPriceListViewModel { return this.$store.state.selectedPriceList; }

    notifyValidationError(errors: ValidationErrors) {
        this.$emit("notify-custom-error", errors);
    }

    @Prop()
    public validationErrors: ValidationErrors;

    @Prop()
    public trustedCustomer: boolean;

    @Prop()
    public testMode: boolean;

    @Emit()
    productsInvalidated() {}

    @Watch("setNewContractModeSelection")


    @Emit()
    nextPhase() { }

    CustomerTypeEnum: typeof CustomerTypeEnum = CustomerTypeEnum;
    SectionMode: typeof SectionMode = SectionMode;
    ActionState: typeof ActionState = ActionState;

    sections: {
        moveOutContracts: SectionState;
        moveOutCustomer: SectionState;
        processSelector: SectionState;
        preProduct: SectionState;
        product: SectionState;
        customer: SectionState;
        company: SectionState;
        moveOutMeteringPoint: SectionState;
    } = null;

    constructor() {
        super();
        console.log("Starting constructor");
        let self = this;
        this.sections = {
            moveOutContracts: new SectionState("move-out-contracts", () => self.$refs.moveOutContracts),
            moveOutCustomer: new SectionState("move-out-customer", () => self.$refs.moveOutCustomer),
            processSelector: new SectionState("move-out-process-selector", () => self.$refs.processSelector),
            preProduct: new SectionState("pre-product", () => self.$refs.preProduct),
            product: new SectionState("product", () => self.$refs.product),
            customer: new SectionState("customer", () => self.$refs.customer),
            company: new SectionState("company", () => self.$refs.company),
            moveOutMeteringPoint: new SectionState("move-out-metering-point", () => self.$refs.moveOutMeteringPoint),
        };
        console.log("Forming section chain");
        SectionState.formChain(
            this.sections.moveOutContracts,
            this.sections.moveOutCustomer,
            this.sections.processSelector,
            this.sections.preProduct,
            this.sections.product,
            this.contract?.CustomerType === CustomerTypeEnum.COMPANY ? this.sections.company : this.sections.customer,
            this.sections.moveOutMeteringPoint
        );
        //his.$store.state.validateMovingProcessByNewContractValidation = true;
    }

    mounted() {
        console.log("Phase mounted!");
        NewContractEvents.addValidationFailedListener(this.validationFailed);
        if (this.$store.state.newContractInitialized) {
            // New contract has already been initialized (i.e. we are coming back from confirmation phase to modify our contract.)
            // In this case we just initialize the sections' states (or the UI).
            this.initializeSections();
        }
        else {
            // New contract has not been initialize, let's register listener for initialization. That listener takes care of
            // sections' initialization after module is initialized.
            console.log("initialize addNewContractInitializedListener...");
            NewContractEvents.addNewContractInitializedListener(this.newContractInitialized);
        }
    }

    beforeDestroy() {
        NewContractEvents.removeValidationFailedListener(this.validationFailed);
        NewContractEvents.removeNewContractInitializedListener(this.newContractInitialized);
    }

    proceedToProductSelection() {
        console.log("Proceed to product selection!");
        this.sections.preProduct.proceed();
    }

    productSelected(product: IProductViewModel, priceList: IPriceListViewModel) {
        this.sections.product.proceed();
    }

    hasMembership(): boolean {
        if (this.contract.Customer.CustomerMemberships || this.contract.MembershipCode) {
            return true;
        }
        return false;
    }

    modifyPreProductSelection() {
        this.sections.preProduct.enter();
    }

    modifyProductSelection() {
        this.sections.product.enter();
    }

    customerTypeSelected() {
        this.sections.preProduct.enter();
    }

    proceedToMeteringPoint() {
        this.sections.product.proceed();
    }

    isProcessSelected: boolean = false;
    processSelected() {
        this.isProcessSelected = true;
    }

    validationFailed(errors: ValidationErrors) {
        this.$nextTick(() => {
            let errorFound = false;
            if (MoveOutContractsChecker.hasErrors(errors)) {
                errorFound = true;
                this.sections.moveOutContracts.enterModify();
            }

            if (!errorFound && MoveOutCustomerChecker.hasErrors(errors)) {
                errorFound = true;
                this.sections.moveOutCustomer.enterModify();
            }
            if (!errorFound && MoveOutProcessSelectorChecker.hasErrors(errors)) {
                errorFound = true;
                this.sections.processSelector.enterModify();
            }

            if (this.contract.ProcessType == ProcessTypeEnum.MOVINGPROCESS || this.contract.ProcessType == ProcessTypeEnum.CONTRACTPROCESS) {

                if (!errorFound && PreProductSelectionChecker.hasErrors(errors)) {
                    errorFound = true;
                    this.sections.preProduct.enterModify();
                }

                if (!errorFound && ProductSelectionChecker.hasErrors(errors)) {
                    errorFound = true;
                    this.sections.product.enterModify();
                }

                if (!errorFound && CustomerInformationChecker.hasErrors(errors)) {
                    errorFound = true;
                    this.sections.customer.enterModify();
                }

                if (!errorFound && CompanyInformationChecker.hasErrors(errors)) {
                    errorFound = true;
                    this.sections.company.enterModify();
                }

                if (!errorFound && MoveOutMeteringPointInformationChecker.hasErrors(errors)) {
                    errorFound = true;
                    this.sections.moveOutMeteringPoint.enterModify();
                }
            }

            let validationIds = errors.getAllKeys();
            let selector = "";
            validationIds.forEach((id) => {
                if (selector)
                    selector += ",";
                selector += "[data-validation-id='" + id + "']";
            });

            let nodeList = this.$el.querySelectorAll(selector);
            let elements = [];
            for (let i = 0; i < nodeList.length; ++i) {
                elements.push(nodeList.item(i));
            }

            elements.sort(function(a, b) {
                if (a === b) return 0;
                if (!a.compareDocumentPosition) {
                    // support for IE8 and below
                    return a.sourceIndex - b.sourceIndex;
                }
                if (a.compareDocumentPosition(b) & 2) {
                    // b comes before a
                    return 1;
                }
                return -1;
            });
        });
    }

    customerValueUpdated(allSet: boolean) {
        if (allSet) {
            console.log("All customer values have been set!");
        }
    }

    companyValueUpdated(allSet: boolean) {
        if (allSet) {
            console.log("All company values have been set!");
        }
    }

    getSectionMode(allSet: boolean, previousSectionMode: SectionMode) {
        let mode = allSet ? SectionMode.Display : SectionMode.Edit;
        if (previousSectionMode != null) {
            if (mode == SectionMode.Edit && previousSectionMode != SectionMode.Display)
                mode = SectionMode.Hidden;
        }
        return mode;
    }


    public setNewContractModeSelection(newSelection: number): void {
        if (newSelection >= 1 && newSelection <= 3)
            $("#PTsel" + newSelection).click();
    }

    initializeSections() {
        console.log("initializeSections() is started!");
        let customerTypeSelected = this.contract.CustomerType != CustomerTypeEnum.NOTSET;
        let stronglyAuthenticated = this.contract.StrongContractAuthentication;

        let moveOutContractsSet = MoveOutContractsChecker.isAllSet(this.contract);
        let consumptionPointsSet = this.contract.MoveOutProcess.ConsumptionPoints.length > 0 && this.contract.MoveOutProcess.ConsumptionPoints[0].MeteringPoints.length > 0;
       
        this.sections.moveOutContracts.initializeMode(moveOutContractsSet && consumptionPointsSet);
        this.sections.moveOutCustomer.initializeMode(MoveOutCustomerChecker.isAllSet(this.contract));

        if (this.contract.ProcessType == ProcessTypeEnum.MOVINGPROCESS) {
            console.log('new mode');
            this.sections.processSelector.initializeMode(true, stronglyAuthenticated ? SectionMode.Hidden : SectionMode.Display);
            this.sections.preProduct.initializeMode(PreProductSelectionChecker.isAllSet(this.contract), stronglyAuthenticated ? SectionMode.Hidden : SectionMode.Display);
            this.sections.product.initializeMode(ProductSelectionChecker.isAllSet(this.contract), stronglyAuthenticated ? SectionMode.Hidden : SectionMode.Display);
            if (this.contract.CustomerType == CustomerTypeEnum.CONSUMER) {
                let isCustomerInformationSet = CustomerInformationChecker.isAllSet(this.contract);
                this.sections.customer.initializeMode(isCustomerInformationSet, stronglyAuthenticated ? SectionMode.Hidden : SectionMode.Display);
            }
            else if (this.contract.CustomerType == CustomerTypeEnum.COMPANY) {
                let isCompanyInformationSet = CompanyInformationChecker.isAllSet(this.contract);
                this.sections.company.initializeMode(isCompanyInformationSet, stronglyAuthenticated ? SectionMode.Hidden : SectionMode.Display);
            }
            else {
                this.sections.customer.mode = SectionMode.Hidden;
            }
            this.sections.moveOutMeteringPoint.initializeMode(MoveOutMeteringPointInformationChecker.isAllSet(this.contract));
        }
        else {
            this.sections.preProduct.initializeMode(PreProductSelectionChecker.isAllSet(this.contract), SectionMode.Hidden);
            this.sections.product.initializeMode(ProductSelectionChecker.isAllSet(this.contract), SectionMode.Hidden);
            if (this.contract.CustomerType == CustomerTypeEnum.CONSUMER) {
                this.sections.customer.initializeMode(CustomerInformationChecker.isAllSet(this.contract), SectionMode.Hidden);
            }
            else if (this.contract.CustomerType == CustomerTypeEnum.COMPANY) {
                this.sections.company.initializeMode(CompanyInformationChecker.isAllSet(this.contract));
            }
            else {
                this.sections.customer.mode = SectionMode.Hidden;
            }
            this.sections.moveOutMeteringPoint.initializeMode(MoveOutMeteringPointInformationChecker.isAllSet(this.contract), SectionMode.Hidden);
        }

        if (stronglyAuthenticated) {
            this.sections.moveOutCustomer.mode = SectionMode.Hidden;
            this.sections.customer.mode = SectionMode.Display;
            this.sections.customer.scrollTo();
            this.sections.customer.enterModify();
            this.setNewContractModeSelection(this.contract.ContractToNewAddressSelection);
        }
        else {
            this.sections.moveOutContracts.scrollToFirstEdit();
        }

    }

    newContractInitialized() {
        console.log("newContractInitialized() started!");
        this.initializeSections();
    }

    newContractMode(): boolean {
        if (this.isProcessSelected
            && ((this.contract.ProcessType == ProcessTypeEnum.MOVINGPROCESS && this.contract.SubProcessType == SubProcessTypeEnum.CONTRACTUPDATE)
                || (this.contract.ProcessType == ProcessTypeEnum.MOVINGPROCESS && this.contract.SubProcessType == SubProcessTypeEnum.MOVINGWITHOLDCONTRACTPRODUCT))) {
            return true;
        }
        return false;
    }

    showNextPhaseButton(): boolean {

        if (this.isProcessSelected && this.contract.ProcessType == ProcessTypeEnum.MOVEOUT
            //&& MoveOutCustomerChecker.isAllSet(this.contract)
        ) {
            return true;
        }
        if (this.isProcessSelected && this.newContractMode()) {
            return true;
        }
        return false;
    }
}
